// src/trendUtils.js

export function buildPeriodKey(createTime, period) {

    const date = new Date(createTime);

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");

    const daily = `${y}-${m}-${d}`;

    switch (period) {

        case "weekly": {

            const d2 = new Date(date);
            const day = d2.getDay();
            const diff = 6 - day;

            d2.setDate(d2.getDate() + diff);

            const y2 = d2.getFullYear();
            const m2 = String(d2.getMonth() + 1).padStart(2, "0");
            const d3 = String(d2.getDate()).padStart(2, "0");

            return `${y2}-${m2}-${d3}`;
        }

        case "monthly":
            return `${y}-${m}`;

        default:
            return daily;
    }
}

function buildBucketMap(list, period, patientMode = false) {

    const map = {};

    list.forEach(item => {

        if (!item.createTime) return;

        const key = buildPeriodKey(
            item.createTime,
            period
        );

        if (!map[key]) {

            map[key] = {
                date: key
            };

        }

        if (patientMode) {

            if (!map[key][item.orgId]) {

                map[key][item.orgId] = new Set();

            }

            map[key][item.orgId]
                .add(item.patientId);

        }
        else {

            map[key][item.orgId] =
                (map[key][item.orgId] || 0) + 1;

        }

    });

    if (patientMode) {

        Object.values(map).forEach(row => {

            Object.keys(row).forEach(org => {

                if (org === "date") return;

                row[org] = row[org].size;

            });

        });

    }

    return map;

}

export function buildDailyTrend(list, period, selectedOrg) {

    const rows = buildOrgTrends(list, period);

    // 👉 非 All 直接返回
    if (selectedOrg !== "All") {
        return rows;
    }

    // 👉 All 模式：合并所有 org
    return rows.map(row => {

        let total = 0;

        Object.keys(row).forEach(key => {
            if (key === "date") return;
            total += row[key] || 0;
        });

        return {
            date: row.date,
            All: total
        };

    });
}

export function buildOrgTrends(list, period) {

    const map =
        buildBucketMap(list, period);

    const result = Object.keys(map)
        .sort((a, b) => new Date(a) - new Date(b))
        .map(key => map[key]);

    return result;
}

export function buildCumulativeTrend(list, period, selectedOrg) {

    if (!Array.isArray(list) || list.length === 0) {
        return [];
    }

    const rows = buildOrgTrends(list, period);

    const result = [];

    let cumulative = 0;

    if (selectedOrg === "All") {

        rows.forEach(row => {

            const periodTotal = Object.keys(row)
                .filter(key => key !== "date")
                .reduce((sum, key) => sum + row[key], 0);

            cumulative += periodTotal;

            result.push({
                date: row.date,
                All: cumulative
            });

        });

    } else {

        rows.forEach(row => {

            cumulative += row[selectedOrg] || 0;

            result.push({
                date: row.date,
                [selectedOrg]: cumulative
            });

        });

    }

    return result;

}